module.exports = __webpack_public_path__ + "img/spins-promotions.67c20965.png";